var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.shouldMessageBeAnimated
        ? _c("TypedText", {
            staticClass: "message",
            attrs: { text: _vm.sanitizedText, interval: 5, steps: 1 },
          })
        : _c("div", {
            staticClass: "message",
            domProps: { innerHTML: _vm._s(_vm.sanitizedText) },
          }),
      _vm._v(" "),
      _c("message-sender", { attrs: { message: _vm.message } }),
      _vm._v(" "),
      _vm.buttonsVisible
        ? _c(
            "div",
            { class: _vm.buttonsWrapperClasses },
            _vm._l(_vm.buttons, function (button) {
              return _c("chatchamp-button", {
                key: button.title,
                attrs: {
                  button: button,
                  message: _vm.message,
                  emphasize: true,
                },
              })
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }